import React, { Component } from "react";

// GraphQL
import { API, Auth, graphqlOperation } from "aws-amplify";
// Components
import marketImage from "../_images/certificado-credito-carbono.png";
import drones from "../_images/drone-con-camara.png";
import blockchain from "../_images/cadena-de-bloques.png";
import plataforma from "../_images/diseno-de-respuesta.png";
import DropDownProjects from "components/common/DropDownProjects";
import NewHeaderNavbar from "components/common/NewHeaderNavbar";
import { navigate } from "../../../utilities/navigate";

export default class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productsLanding: [],
      productsImagesIsOnCarousel: [],
      userLogged: false,
      show: false
    }
    this.logOut = this.logOut.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  componentDidMount = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser()
      this.setState({ userLogged: { username: user.username, role: user.attributes["custom:role"] } })
    } catch (error) {

    }
    //await this.loadProducts()
  }
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    if (this.state.userLogged && this.state.userLogged.role === 'constructor') return navigate('/new_campaign');
    this.setState({ show: true });
  }

  async loadProducts() {
    const limit = 6;
    const query = `query ListProducts($limit: Int) {
      listProducts(limit: $limit) {
        items {
          id
          name
          description
          isActive
          order
          status
          categoryID
          category {
            id
            name
            isSelected
            createdAt
            updatedAt
          }
          images {
            nextToken
            items {
              id
              imageURL
              carouselDescription
              carouselLabel
              format
              isOnCarousel
              isActive
              imageURLToDisplay
              title
              productID
              order
            }
          }
          productFeatures {
            items {
              id
              isToBlockChain
              value
              productID
              feature {
                id
                name
                isTemplate
                description
                featureType {
                  name
                  id
                  description
                }
                unitOfMeasure {
                  engineeringUnit
                  id
                }
              }
              productFeatureResults {
                items {
                  id
                  isActive
                  result {
                    id
                    value
                    formula {
                      id
                      equation
                    }
                  }
                }
              }
            }
          }
          userProducts {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken 
      }
    }`;

    const listProductsResult = await API.graphql(graphqlOperation(query));
    /* let tempProductsImagesIsOnCarousel = this.state.productsImagesIsOnCarousel */
    let tempListProductsResult = listProductsResult.data.listProducts.items.map(
      (product) => {
        return product;
      }
    );
    tempListProductsResult.sort((a, b) => (a.order > b.order ? 1 : -1));
    let productsLanding = [];
    tempListProductsResult.map((product) => {
      if (
        product.images.items.length > 0 &&
        product.productFeatures.items.length > 0 &&
        product.status !== "draft" &&
        product.status !== "rejected"
      )
        productsLanding.push(product);
    });
    this.setState({
      productsLanding:
        productsLanding /* , productsImagesIsOnCarousel: tempProductsImagesIsOnCarousel */,
    });
  }
  async logOut() {
    await Auth.signOut();
    localStorage.removeItem("role");
    navigate("/");
  }

  render() {
    const headingClass =
      "mb-10 text-center font-jost text-2xl font-bold tracking-wide text-terrasacha-secondary1 sm:mb-14 sm:text-4xl";
    const bodyClass =
      "font-jost text-base leading-relaxed text-terrasacha-secondary1 sm:text-lg";
    const sectionWrapClass = "mx-auto w-full max-w-6xl px-4 sm:px-6";
    const ctaGridClass = this.state.userLogged
      ? "mx-auto grid w-full max-w-xs grid-cols-1 gap-3"
      : "mx-auto grid w-full max-w-xl grid-cols-1 gap-3 sm:max-w-2xl sm:grid-cols-2 sm:gap-4";
    const primaryButtonClass =
      "inline-flex h-14 w-full items-center justify-center rounded-xl bg-terrasacha-secondary2 px-6 font-jost text-base font-bold text-white shadow-terrasacha-lg transition-all duration-300 hover:bg-terrasacha-primary";
    const joinButtonClass =
      "inline-flex h-14 w-full items-center justify-center rounded-xl bg-terrasacha-secondary2 px-6 font-jost text-base font-bold text-white shadow-terrasacha-lg transition-all duration-300 hover:bg-terrasacha-light";
    const projectButtonClass =
      "h-14 w-full rounded-xl bg-white px-6 font-jost text-base font-bold text-terrasacha-secondary1 shadow-terrasacha-lg transition-all duration-300 hover:bg-terrasacha-earth";
    const reasonCardClass =
      "flex h-full flex-col items-center space-y-4 rounded-xl bg-white p-6 text-center shadow-terrasacha transition-all duration-300 hover:-translate-y-2 hover:shadow-terrasacha-lg sm:p-8";
    const technologies = [
      {
        title: "BLOCKCHAIN",
        image: blockchain,
        alt: "blockchain",
        circleClass: "bg-terrasacha-primary",
        text: "Revolucionamos los mercados de carbono al hacer públicas e inmutables todas las transacciones, estableciendo un estándar inigualable de transparencia. Cada proceso de eliminación de carbono se origina, rastrea y completa en la cadena de bloques.",
      },
      {
        title: "DRONES",
        image: drones,
        alt: "drones",
        circleClass: "bg-terrasacha-secondary2",
        text: "Utilizamos drones para la revisión de los terrenos y emitir los resultados de la reducción de CO2",
      },
      {
        title: "PLATAFORMA TERRASACHA",
        image: plataforma,
        alt: "plataforma",
        circleClass: "bg-terrasacha-light",
        text: "Ten control total de tus proyectos y de tus inversiones desde nuestra plataforma, conecta facilmente tu wallet con nosotros y obten tus tokens de manera inmediata.",
      },
    ];

    return (
      <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-terrasacha-primary to-terrasacha-secondary2 font-jost">
        <NewHeaderNavbar/>
        
        {/* Hero Section */}
        <section className="relative flex min-h-[100dvh] items-center justify-center bg-gradient-terrasacha-dark px-4 pb-16 pt-24 text-white animate-fade-in sm:px-6 sm:pt-28">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-90"
              style={{
                backgroundImage: `url('/nature.png')`,
              }}
            ></div>
          </div>
          <div className="relative z-10 mx-auto w-full max-w-6xl text-center">
            <h1 className="mx-auto mb-6 max-w-4xl font-jost text-3xl font-bold leading-tight animate-slide-up sm:text-4xl md:text-5xl lg:text-6xl">
              Aceleramos la transición hacia un mundo de{" "}
              <span className="text-terrasacha-earth">carbono neutral</span>
            </h1>
            <p className="mx-auto mb-8 max-w-3xl font-jost text-base leading-relaxed animate-slide-up sm:mb-12 sm:text-xl md:text-2xl" style={{animationDelay: '0.3s'}}>
              Una <strong>plataforma</strong> para <strong>invertir</strong> en{" "}
              <strong>activos ambientales</strong> en desarrollo, fácil, rápido y seguro.
            </p>
            <div className={`${ctaGridClass} animate-slide-up`} style={{animationDelay: '0.6s'}}>
              {!this.state.userLogged && (
                <button
                  className={primaryButtonClass}
                  onClick={this.handleShow}
                >
                  Tengo un proyecto
                </button>
              )}
              <DropDownProjects className={projectButtonClass}/>
            </div>
          </div>
        </section>

        {/* Modal */}
        {this.state.show && (
          <div
            className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-0 animate-scale-in sm:items-center sm:p-4"
            onClick={this.handleClose}
            role="presentation"
          >
            <div
              className="flex max-h-[92dvh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-white shadow-terrasacha-2xl sm:max-h-[90dvh] sm:rounded-2xl"
              role="dialog"
              aria-modal="true"
              aria-labelledby="postular-proyecto-titulo"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="relative border-b border-terrasacha-light bg-terrasacha-earth px-12 py-4 sm:py-6">
                <span id="postular-proyecto-titulo" className="block text-center font-jost text-base font-bold leading-snug text-terrasacha-secondary1 sm:text-xl">
                  ¿CÓMO POSTULAR MI PROYECTO?
                </span>
                <button
                  onClick={this.handleClose}
                  className="absolute right-4 top-1/2 -translate-y-1/2 px-1 font-jost text-2xl font-bold leading-none text-terrasacha-secondary1 transition-all duration-300 hover:text-terrasacha-primary"
                  aria-label="Cerrar"
                >
                  ×
                </button>
              </div>
              
              <div className="overflow-y-auto p-4 sm:p-6">
                <ol className="mx-auto max-w-xl space-y-4 font-jost text-sm text-terrasacha-secondary1 sm:text-base">
                  <li className="flex items-start">
                    <span className="mr-3 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terrasacha-primary text-sm font-bold text-white">1</span>
                    <span>Da Click en Registrarme y completa tus datos, escoge en rol <strong>Propietario</strong></span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terrasacha-primary text-sm font-bold text-white">2</span>
                    <span>Ve a Perfil y luego a postular proyecto</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terrasacha-primary text-sm font-bold text-white">3</span>
                    <span>Completa la información de tu proyecto</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terrasacha-primary text-sm font-bold text-white">4</span>
                    <span>Tu proyecto será revisado y complementado por nuestros Consultores</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-terrasacha-primary text-sm font-bold text-white">5</span>
                    <span>Revisa la información adicional y aceptala, para que quede publicado en el Marketplace</span>
                  </li>
                </ol>
              </div>
              
              <div className="border-t border-terrasacha-light bg-terrasacha-earth p-4 text-center sm:p-6">
                <a
                  className="inline-flex h-12 min-w-[12rem] items-center justify-center rounded-lg bg-terrasacha-primary px-6 font-jost font-bold text-white shadow-terrasacha transition-all duration-300 hover:bg-terrasacha-secondary1"
                  href='/login'
                >
                  Registrarme
                </a>
              </div>
            </div>
          </div>
        )}

        {/* CO2 Reduction Section */}
        <div className="bg-gradient-terrasacha-subtle py-16 sm:py-20">
          <div className={sectionWrapClass}>
            <div className="grid items-center gap-10 md:grid-cols-2 md:gap-16">
              <div className="mx-auto flex w-full max-w-xl flex-col items-center space-y-4 text-center sm:space-y-6">
                <h2 className="font-jost text-2xl font-bold tracking-wide text-terrasacha-secondary1 sm:text-4xl">
                  REDUCIMOS EL CO2
                </h2>
                <p className={bodyClass}>
                  Adquiere la capacidad de <strong>neutralizar carbono</strong>,
                  respalda la agricultura regenerativa y genera un impacto en el
                  que puedas confiar plenamente.
                </p>
                <p className={bodyClass}>
                  Cada Tonelada está respaldada por <strong>tecnología Blockchain</strong>, 
                  y se entrega con un certificado que ofrece una transparencia total sobre el
                  proyecto específico de eliminación de carbono.
                </p>
              </div>
              <div className="flex justify-center">
                <img
                  src={marketImage}
                  alt="Certificado de crédito de carbono Terrasacha: 1 tonelada de CO2 equivalente a 1 crédito de carbono"
                  className="aspect-[3/2] h-auto w-full max-w-xl rounded-2xl object-contain shadow-terrasacha-xl"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Why Terrasacha Section */}
        <div className="scroll-mt-20 bg-terrasacha-earth py-16 sm:py-20" id="porque">
          <div className={sectionWrapClass}>
            <h2 className={headingClass}>
              ¿POR QUÉ TERRASACHA?
            </h2>
            <div className="grid grid-cols-1 items-stretch gap-6 sm:grid-cols-2 sm:gap-8 xl:grid-cols-4">
              <div className={reasonCardClass}>
                <div className="w-24 h-24 mx-auto bg-terrasacha-primary rounded-full flex items-center justify-center shadow-terrasacha">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 -960 960 960"
                  >
                    <path d="M80-160v-120h80v-440q0-33 23.5-56.5T240-800h600v80H240v440h240v120H80Zm520 0q-17 0-28.5-11.5T560-200v-400q0-17 11.5-28.5T600-640h240q17 0 28.5 11.5T880-600v400q0 17-11.5 28.5T840-160H600Zm40-120h160v-280H640v280Zm0 0h160-160Z" />
                  </svg>
                </div>
                <h4 className="font-jost text-xl font-bold text-terrasacha-secondary1">Tecnología</h4>
                <p className="flex-1 font-jost text-terrasacha-secondary1">
                  Nuestra plataforma se apalanca en tecnología blockchain para
                  lograr total transparencia en los proyectos
                </p>
              </div>
              
              <div className={reasonCardClass}>
                <div className="w-24 h-24 mx-auto bg-terrasacha-primary rounded-full flex items-center justify-center shadow-terrasacha">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 -960 960 960"
                  >
                    <path d="M480-80 120-280v-400l360-200 360 200v400L480-80ZM364-590q23-24 53-37t63-13q33 0 63 13t53 37l120-67-236-131-236 131 120 67Zm76 396v-131q-54-14-87-57t-33-98q0-11 1-20.5t4-19.5l-125-70v263l240 133Zm40-206q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400Zm40 206 240-133v-263l-125 70q3 10 4 19.5t1 20.5q0 55-33 98t-87 57v131Z" />
                  </svg>
                </div>
                <h4 className="font-jost text-xl font-bold text-terrasacha-secondary1">Confianza</h4>
                <p className="flex-1 font-jost text-terrasacha-secondary1">
                  Tus inversiones se verán reflejadas en tokens que con el
                  tiempo aumentarán su valor
                </p>
              </div>
              
              <div className={reasonCardClass}>
                <div className="w-24 h-24 mx-auto bg-terrasacha-primary rounded-full flex items-center justify-center shadow-terrasacha">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 -960 960 960"
                  >
                    <path d="M280-80v-160H0l154-240H80l280-400 120 172 120-172 280 400h-74l154 240H680v160H520v-160h-80v160H280Zm389-240h145L659-560h67L600-740l-71 101 111 159h-74l103 160Zm-523 0h428L419-560h67L360-740 234-560h67L146-320Zm0 0h155-67 252-67 155-428Zm523 0H566h74-111 197-67 155-145Zm-149 80h160-160Zm201 0Z" />
                  </svg>
                </div>
                <h4 className="font-jost text-xl font-bold text-terrasacha-secondary1">Compromiso</h4>
                <p className="flex-1 font-jost text-terrasacha-secondary1">
                  Estamos comprometidos 100% con el medio ambiente
                </p>
              </div>
              
              <div className={reasonCardClass}>
                <div className="w-24 h-24 mx-auto bg-terrasacha-primary rounded-full flex items-center justify-center shadow-terrasacha">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 -960 960 960"
                  >
                    <path d="M480-100q-79 0-148-30t-120.5-81.5Q160-263 130-332t-30-148q0-79 30-148t81.5-120.5Q263-800 332-830t148-30v-100l160 160-160 160v-100q-108 0-184 76t-76 184q0 66 30.5 122.5T332-266q16-28 47.5-47.5T452-338q-3-21-8-42t-12-39q-11 9-24 14t-28 5q-33 0-56.5-23.5T300-480v-40q0-17-5.5-32T280-580q50-1 89 9 34 9 62 29.5t29 61.5q0 9-1.5 16.5T453-448q-13-10-26-18t-27-14q17 13 39 40t41 64q20-49 50-96.5t70-87.5q-23 16-44 34t-41 38q-7-11-11-24.5t-4-27.5q0-42 29-71t71-29h40q23 0 38-6t25-14q11-9 17-20 4 67-7 120-9 45-34 82.5T600-440q-15 0-28.5-4T547-455q-7 19-16 50.5T517-337q38 7 67 26t44 45q51-35 81.5-91T740-480h120q0 79-30 148t-81.5 120.5Q697-160 628-130t-148 30Z" />
                  </svg>
                </div>
                <h4 className="font-jost text-xl font-bold text-terrasacha-secondary1">Experiencia</h4>
                <p className="flex-1 font-jost text-terrasacha-secondary1">
                  Contamos con un equipo de expertos que se asegurarán de
                  completar y calificar cada proyecto.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Technology Section */}
        <div className="scroll-mt-20 bg-gradient-terrasacha-subtle py-16 sm:py-20" id="tecnologia">
          <div className={sectionWrapClass}>
            <h2 className={headingClass}>
              NUESTRA TECNOLOGÍA
            </h2>

            <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-3 md:gap-8">
              {technologies.map((item) => (
                <article key={item.title} className="flex h-full flex-col items-center rounded-2xl bg-white p-6 text-center shadow-terrasacha sm:p-8">
                  <div className={`mb-6 flex h-28 w-28 shrink-0 items-center justify-center rounded-full shadow-terrasacha-xl ${item.circleClass}`}>
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="h-16 w-16 object-contain"
                    />
                  </div>
                  <h3 className="mb-3 flex min-h-[4.5rem] items-center justify-center font-jost text-xl font-bold leading-tight text-terrasacha-secondary1 sm:text-2xl">
                    {item.title}
                  </h3>
                  <p className={`${bodyClass} flex-1`}>
                    {item.text}
                  </p>
                </article>
              ))}
            </div>
          </div>

          {/* Join Us Section */}
          <div className="mt-16 bg-terrasacha-primary py-16 sm:mt-20 sm:py-20">
            <div className={`${sectionWrapClass} text-center`}>
              <h2 className="mb-10 font-jost text-2xl font-bold tracking-wide text-white sm:mb-14 sm:text-4xl">
                SE PARTE DE NOSOTROS
              </h2>
              <div className={ctaGridClass}>
                {!this.state.userLogged && (
                  <button
                    className={joinButtonClass}
                    onClick={this.handleShow}
                  >
                    Tengo un proyecto
                  </button>
                )}
                <DropDownProjects className={projectButtonClass}/>
              </div>
            </div>
          </div>

          {/* Learn More Section */}
          <div className={`${sectionWrapClass} py-16 sm:py-20`}>
            <h2 className={headingClass}>
              ¿Quieres conocer más?
            </h2>
            <div className="mx-auto grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
              <a
                className="inline-flex h-14 items-center justify-center rounded-xl bg-white px-6 text-center font-jost text-base font-bold text-terrasacha-secondary1 shadow-terrasacha-lg transition-all duration-300 hover:bg-terrasacha-earth"
                href="https://terrasacha.gitbook.io/terrasacha/readme/guia-de-usuario"
                target="_blank"
                rel="noreferrer"
              >
                ¿Como entrar?
              </a>
              <a
                className="inline-flex h-14 items-center justify-center rounded-xl bg-white px-6 text-center font-jost text-base font-bold text-terrasacha-secondary1 shadow-terrasacha-lg transition-all duration-300 hover:bg-terrasacha-earth"
                href="https://terrasacha.gitbook.io/terrasacha"
                target="_blank"
                rel="noreferrer"
              >
                Documentación técnica
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

